<template>
  <v-menu bottom :dark="darkEnabled" :content-class="menuContentClass">
    <template v-slot:activator="{ on }">
      <v-btn
        :text="flat"
        :icon="icon"
        :color="type"
        rounded
        v-on="on"
        :disabled="disabled"
        class="formButton"
        :loading="loading"
      >
        <slot>{{ text }}</slot>
      </v-btn>
    </template>

    <v-list :dark="darkEnabled">
      <v-list-item
        v-for="(opt, index) in options"
        :key="'list-item-' + randomId + '-' + index"
        @click="onClick(opt)"
        :disabled="Object.keys(opt).includes('disable') ? opt.disable : false"
      >
        <v-list-item-title>
          <slot :name="opt.value" :item="opt">
            {{ opt.text }}
          </slot>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FormButtonMenu",
  props: {
    text: {
      type: String,
      default: "",
      required: false
    },
    flat: {
      type: Boolean,
      default: false,
      required: false
    },
    icon: {
      type: Boolean,
      default: false,
      required: false
    },
    type: {
      type: String,
      default: "",
      required: false
    },
    options: {
      type: Array,
      default: () => [],
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    loading: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    randomId: Math.random() * 1000
  }),
  computed: {
    ...mapGetters(["darkEnabled"]),
    menuContentClass() {
      return this.darkEnabled ? "form-button-menu-dark" : "";
    }
  },
  methods: {
    onClick(option) {
      this.$emit("click", option);
    }
  }
};
</script>

<style>
.v-menu__content.form-button-menu-dark {
  background: var(--dark-surface, #1d1d1d) !important;
}

.v-menu__content.form-button-menu-dark .v-list {
  background: var(--dark-surface, #1d1d1d) !important;
}

.v-menu__content.form-button-menu-dark
  .v-list
  .v-list-item:not(.v-list-item--disabled) {
  color: rgba(255, 255, 255, 0.87) !important;
}

.v-menu__content.form-button-menu-dark .v-list-item__title,
.v-menu__content.form-button-menu-dark .v-list-item__subtitle {
  color: rgba(255, 255, 255, 0.87) !important;
}

.v-menu__content.form-button-menu-dark .v-list-item__content,
.v-menu__content.form-button-menu-dark .v-list-item__content p,
.v-menu__content.form-button-menu-dark .v-list-item__content small,
.v-menu__content.form-button-menu-dark .v-list-item > div,
.v-menu__content.form-button-menu-dark .v-list-item p,
.v-menu__content.form-button-menu-dark .v-list-item small {
  color: rgba(255, 255, 255, 0.87) !important;
}

.v-menu__content.form-button-menu-dark .v-divider {
  border-color: rgba(255, 255, 255, 0.12) !important;
}
</style>
